import { useQuery } from '@tanstack/react-query';
import useUser from '../global/useUser';
import { getBusinessSettings } from '../../services/business';

function useGetBusinessSettings() {
  const { user } = useUser();

  const isEnabled = !!user?.business?.id && user?.business?.type === 'STUDIO';

  const { data, isLoading, isFetching, isError, error, refetch } = useQuery({
    queryKey: ['businessSettings', user?.userId, user?.business?.id],
    queryFn: async () => {
      if (!user?.business?.id) return null;
      const settings = await getBusinessSettings(user?.business?.id);
      return settings;
    },
    enabled: isEnabled,
  });

  return {
    settings: data,
    isLoading,
    isFetching,
    isError,
    error,
    refetch,
    isEnabled,
  };
}

export default useGetBusinessSettings;
